import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=055dc237&scoped=true&"
import script from "./OrderHeader.vue?vue&type=script&lang=js&"
export * from "./OrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=055dc237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055dc237",
  null
  
)

export default component.exports